function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  r: 24,
  transform: "matrix(1 0 0 -1 24 24)",
  fill: "#CACAF1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 24L23.5455 9L33.0909 24L23.5455 29.4545L14 24Z",
  fill: "#9FA8DA"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5459 9L33.0914 24L23.5459 29.4545V9Z",
  fill: "#7986CB"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14 26.0455L23.5455 31.5L33.0909 26.0455L23.5455 39L14 26.0455Z",
  fill: "#9FA8DA"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5459 31.5L33.0914 26.0455L23.5459 39V31.5Z",
  fill: "#7986CB"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M14 24L23.5455 19.9091L33.0909 24L23.5455 29.4545L14 24Z",
  fill: "#7986CB"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5459 19.9091L33.0914 24L23.5459 29.4545V19.9091Z",
  fill: "#5C6BC0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M106 51C119.255 51 130 40.2548 130 27C130 13.7452 119.255 3 106 3C92.7452 3 82 13.7452 82 27C82 40.2548 92.7452 51 106 51Z",
  fill: "#10BA97"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M110.06 33.6698H113.471C113.947 33.6698 114.305 33.5774 114.546 33.3926C114.787 33.2078 114.907 32.9166 114.907 32.519C114.907 32.1214 114.787 31.8302 114.546 31.6454C114.305 31.455 113.947 31.3598 113.471 31.3598H110.06V30.0998H113.403C114.243 30.0998 114.885 30.307 115.327 30.7214C115.769 31.1302 115.991 31.7294 115.991 32.519C115.991 33.3086 115.769 33.9078 115.327 34.3166C114.885 34.7254 114.243 34.9298 113.403 34.9298H110.06V33.6698Z",
  fill: "#1E1A31"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M114.025 28.1378C114.316 28.1154 114.551 27.9978 114.731 27.785C114.904 27.5666 114.991 27.2782 114.991 26.9198C114.991 26.623 114.929 26.3822 114.806 26.1974C114.677 26.007 114.501 25.9118 114.277 25.9118C114.12 25.9118 113.997 25.965 113.907 26.0714C113.812 26.1722 113.739 26.3178 113.689 26.5082C113.633 26.693 113.566 26.9814 113.487 27.3734C113.415 27.7598 113.322 28.0846 113.21 28.3478C113.093 28.611 112.922 28.8266 112.698 28.9946C112.468 29.157 112.166 29.2382 111.791 29.2382C111.449 29.2382 111.144 29.1458 110.875 28.961C110.606 28.7706 110.396 28.5102 110.245 28.1798C110.088 27.8438 110.01 27.4658 110.01 27.0458C110.01 26.6146 110.091 26.2282 110.253 25.8866C110.41 25.5394 110.629 25.2678 110.909 25.0718C111.189 24.8702 111.505 24.7666 111.858 24.761V25.9958C111.606 26.0238 111.404 26.1302 111.253 26.315C111.096 26.4998 111.018 26.7434 111.018 27.0458C111.018 27.3258 111.077 27.5498 111.194 27.7178C111.312 27.8858 111.48 27.9698 111.698 27.9698C111.855 27.9698 111.978 27.9194 112.068 27.8186C112.152 27.7178 112.222 27.575 112.278 27.3902C112.328 27.2054 112.39 26.9198 112.463 26.5334C112.535 26.1414 112.628 25.811 112.74 25.5422C112.846 25.2734 113.011 25.0578 113.235 24.8954C113.454 24.7274 113.748 24.6434 114.117 24.6434C114.476 24.6434 114.798 24.7414 115.083 24.9374C115.363 25.1334 115.585 25.4078 115.747 25.7606C115.909 26.1078 115.991 26.4998 115.991 26.9366C115.991 27.407 115.907 27.827 115.739 28.1966C115.565 28.5606 115.327 28.8462 115.025 29.0534C114.722 29.2606 114.383 29.367 114.008 29.3726L114.025 28.1378Z",
  fill: "#1E1A31"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M110.06 23.8874V21.8462C110.06 21.2582 110.186 20.7402 110.438 20.2922C110.685 19.8386 111.032 19.4914 111.48 19.2506C111.922 19.0042 112.429 18.881 113 18.881C113.571 18.881 114.081 19.0042 114.529 19.2506C114.971 19.4914 115.319 19.8386 115.571 20.2922C115.817 20.7402 115.94 21.2582 115.94 21.8462V23.8874H110.06ZM114.89 21.8462C114.89 21.3142 114.719 20.9026 114.378 20.6114C114.031 20.3146 113.571 20.1662 113 20.1662C112.429 20.1662 111.973 20.3146 111.631 20.6114C111.284 20.9026 111.11 21.3142 111.11 21.8462V22.6274H114.89V21.8462Z",
  fill: "#1E1A31"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M96.3991 35.194L94.6514 33.9471L105.644 18.674L107.391 19.9208L96.3991 35.194Z",
  fill: "#1E1A31"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M102.061 25.9289H102.648C105.35 25.9289 107.54 28.1118 107.54 30.8045C107.54 33.4972 105.35 35.68 102.648 35.68H95.4545C94.861 35.68 94.3799 35.2005 94.3799 34.6089C94.3799 34.0174 94.861 33.5379 95.4545 33.5379H102.648C104.163 33.5379 105.391 32.3141 105.391 30.8045C105.391 29.2949 104.163 28.0711 102.648 28.0711H99.8588H99.8583H99.2716C96.57 28.0711 94.3799 25.8882 94.3799 23.1955C94.3799 20.5029 96.57 18.32 99.2716 18.32H106.465C107.059 18.32 107.54 18.7995 107.54 19.3911C107.54 19.9826 107.059 20.4622 106.465 20.4622H99.2716C97.757 20.4622 96.5291 21.6859 96.5291 23.1955C96.5291 24.7052 97.757 25.9289 99.2716 25.9289H102.061C102.061 25.9289 102.061 25.9289 102.061 25.9289Z",
  fill: "#1E1A31"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M75.1514 55.0343L75.3478 55.4941L75.3478 55.4941L75.1514 55.0343ZM79.9186 52.613C80.1749 52.7158 80.2993 53.007 80.1964 53.2632L78.5205 57.4395C78.4177 57.6958 78.1265 57.8202 77.8702 57.7173C77.614 57.6145 77.4896 57.3234 77.5924 57.0671L79.0821 53.3548L75.3699 51.8651C75.1136 51.7623 74.9892 51.4712 75.0921 51.2149C75.1949 50.9586 75.486 50.8342 75.7423 50.9371L79.9186 52.613ZM74.9549 54.5745L79.5359 52.6172L79.9288 53.5368L75.3478 55.4941L74.9549 54.5745ZM47.0372 51.6232C55.2011 57.383 65.7671 58.5 74.9549 54.5745L75.3478 55.4941C65.8409 59.5559 54.9081 58.4001 46.4607 52.4403L47.0372 51.6232Z",
  fill: "#484697"
});

var SvgBuySUsd = function SvgBuySUsd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 63,
    viewBox: "0 0 130 63",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBuySUsd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/buy-sUSD.0ee47a35.svg";
export { ForwardRef as ReactComponent };